export default __webpack_public_path__ + "static/figure-gallery-2-reference-a65fbbcd66324af4be51a94414e0bef7.jpg";